module.exports = __webpack_public_path__ + "docs/img/ground.1d811d70.png";